import * as React from 'react';
import Grid from '@mui/material/Grid';
import Modal from '@mui/material/Modal';

interface ICustomModalProps {
  isOpen: boolean;
  onClose?: () => void;
  children: React.ReactNode;
  xs?: number;
  width?: number | string;
  md?: number;
  lg?: number;
}

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  borderRadius: '10px',
  border: 'border: 0.5px solid var(--Brand-Salmon-Pink, #FEE4DB)',
  boxShadow: '0px 4px 40px 0px rgba(255, 181, 171, 0.20)',
};

const CustomModal = ({ isOpen, onClose, children, xs, width, md, lg }: ICustomModalProps) => (
  <Modal
    open={isOpen}
    onClose={onClose}
    closeAfterTransition
    data-testid="modal-content"
    sx={{
      '& .MuiBackdrop-root': {
        backgroundColor: 'primary.main',
        opacity: '0.5 !important',
        outline: 'none',
      },
    }}
  >
    <Grid
      container
      item
      sx={{ ...modalStyle, outline: 'none' }}
      xs={xs}
      md={md}
      lg={lg}
      width={width}
      justifyContent="center"
      minWidth="350px"
    >
      {children}
    </Grid>
  </Modal>
);

export default CustomModal;
